import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle, Eye, Lightbulb } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { PriorityDecision } from '@/hooks/useDashboardInsights';

interface PriorityDecisionCardProps {
  decision: PriorityDecision;
}

export const PriorityDecisionCard: React.FC<PriorityDecisionCardProps> = ({
  decision,
}) => {
  const statusBorderColors = {
    good: 'border-l-emerald-500',
    attention: 'border-l-amber-500',
    action: 'border-l-red-500',
  };

  const iconComponents = {
    alert: AlertCircle,
    eye: Eye,
    lightbulb: Lightbulb,
  };

  const IconComponent = iconComponents[decision.icon];

  return (
    <Card className={cn(
      'border-l-4 bg-card',
      statusBorderColors[decision.status]
    )}>
      <CardContent className="p-5">
        <div className="space-y-3">
          {/* Title with icon */}
          <div className="flex items-start gap-2">
            <IconComponent className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
            <h3 className="font-semibold text-foreground leading-tight">
              {decision.title}
            </h3>
          </div>

          {/* Description */}
          <p className="text-sm text-muted-foreground pl-6">
            {decision.description}
          </p>

          {/* Recommendation */}
          <p className="text-sm font-medium italic text-muted-foreground pl-6">
            {decision.recommendation}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
